import { render, staticRenderFns } from "./info-documents.vue?vue&type=template&id=33a5afbd&scoped=true&"
import script from "./info-documents.vue?vue&type=script&lang=js&"
export * from "./info-documents.vue?vue&type=script&lang=js&"
import style0 from "./info-documents.vue?vue&type=style&index=0&id=33a5afbd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a5afbd",
  null
  
)

export default component.exports